// Brief summaries of verified work; the full details live on the linked pages.
export const workStories = [
  {
    id: "yamaha",
    name: "Data & analytics",
    company: "Yamaha",
    context: "YAMAHA · DATA ANALYST CO-OP",
    title: "From data to decisions.",
    summary:
      "Python pipelines and Power BI dashboards connecting sales data with forecasting and financial planning.",
    to: "/experience#yamaha-motor-canada",
    link: "Explore my Yamaha experience",
    curve: "M120 178C248 178 250 25 350 48S420 83 468 83",
  },
  {
    id: "jonas",
    name: "Applied AI",
    company: "Jonas",
    context: "JONAS · AI ENABLEMENT INTERN",
    title: "AI that fits the workflow.",
    summary:
      "Automations that turn unstructured information into useful outputs for HR, finance, and internal operations.",
    to: "/experience#jonas-software",
    link: "Explore my Jonas experience",
    curve: "M468 83C553 118 553 231 468 267",
  },
  {
    id: "luckylease",
    name: "Software",
    company: "LuckyLease",
    context: "LUCKYLEASE · GROUP PROJECT",
    title: "Built for finding a fit.",
    summary:
      "A student sublet marketplace our group built with real-time chat, map-based discovery, and personalized AI advice.",
    to: "/projects/lucky-lease",
    link: "Explore the LuckyLease project",
    curve: "M120 178C233 178 260 296 365 282S426 267 468 267",
  },
];
